import { useEffect, useState } from 'react';
import { FeatureFlag, getFeatureFlags } from '../../api';

const useCountriesFeatureFlags = (): { features: FeatureFlag, error?: Error, loading: boolean } => {
  const [features, setFeatures] = useState<FeatureFlag>({ signUpAvailable: [] });
  const [error, setError] = useState<Error | undefined>();

  useEffect(() => {
    getFeatureFlags()
      .then(setFeatures)
      .catch(error => {
        setError(error);
      });

  }, []);

  return { features, error, loading: !features && !error };
}

export default useCountriesFeatureFlags;
